import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue'
import request from './utils/request'
import db from './utils/localstorage'
import VueApexCharts from 'vue-apexcharts'
//  全局引入Echarts
import * as echarts from 'echarts'
// 引入富文本编辑器
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import 'ant-design-vue/dist/antd.css'
import version from '../static/version.json'
import { tree } from '@/utils/getMuneList'
import { getListStatistics } from '@/utils/index'

import VueDraggableResizable from 'vue-draggable-resizable'
// import 'vue-draggable-resizable/dist/VueDraggableResizable.css'

import './utils/install'

import './styles/topsearch.less'

Vue.config.productionTip = false
Vue.use(db)
Vue.use(Antd)
Vue.use(VueApexCharts)
Vue.use(VueQuillEditor)

Vue.component('apexchart', VueApexCharts)

Vue.component('vue-draggable-resizable', VueDraggableResizable)

Vue.use({
  install (Vue) {
    Vue.prototype.$db = db
  }
})
Vue.prototype.$version = version.version
Vue.prototype.$echarts = echarts
Vue.prototype.$post = request.post
Vue.prototype.$postJson = request.postJson
Vue.prototype.$constURL = request.constURL
Vue.prototype.$get = request.get
Vue.prototype.$put = request.put
Vue.prototype.$putJson = request.putJson
Vue.prototype.$delete = request.delete
Vue.prototype.$export = request.export
Vue.prototype.$download = request.download
Vue.prototype.$upload = request.upload
Vue.prototype.$DocExport = request.DocExport
Vue.prototype.$baseURL = request.constURL
Vue.prototype.$tree = tree
Vue.prototype.$getListStatistics = getListStatistics

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js